import { db, FirebaseDocRefType } from 'firebase/index'
import { SwitchingStoreRefType } from 'types/auth'
import { Action, Dispatch } from 'redux'
import { State } from 'index'
import { StaffType } from 'types/staff'
import { fetchEventRefs, isListedStaff } from 'reducks/staff/operations'
import { fetchStaffsAction } from 'reducks/staff/actions'

const fetchStaffs = (storeRef: FirebaseDocRefType, switchingStoreRefs: SwitchingStoreRefType[]) => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    const uid = getState().auth.uid
    const staffs: StaffType[] = []
    const eventRefs = await fetchEventRefs()
    await db
      .collection('staffs')
      .get()
      .then((snapshots) => {
        snapshots.forEach((snapshot) => {
          const data = snapshot.data() as StaffType
          // スーパー管理者は除外
          if (data.is_admin) return
          // スタッフの権限がSS以外の切り替え可能店舗であれば追加
          if (isListedStaff(data, switchingStoreRefs, eventRefs)) {
            staffs.push(data)
          }
        })
      })
    // 操作中のユーザーを配列の先頭にする
    const sortedStaffs = staffs.reduce((prev: StaffType[], staff: StaffType) => {
      if (staff.uid === uid) {
        return [staff, ...prev]
      } else {
        return [...prev, staff]
      }
    }, [])
    dispatch(fetchStaffsAction(sortedStaffs))
  }
}

export default fetchStaffs
